import axios from "axios";
import { toast } from "sonner";

/**
 * Download a CSV from an authenticated API endpoint.
 *
 * Fetches via axios (so the JWT interceptor adds the auth header) and then
 * triggers a browser download from the blob.  Falls back to a toast on
 * failure.
 *
 * @param {string} url - full or `API`-relative URL to the CSV endpoint
 * @param {string} [defaultName] - filename hint if the server omits one
 */
export async function downloadCsv(url, defaultName = "export.csv") {
  try {
    const res = await axios.get(url, { responseType: "blob" });
    // Pull filename out of Content-Disposition when the server sets it.
    const disp = res.headers["content-disposition"] || "";
    const match = /filename="?([^"]+)"?/i.exec(disp);
    const filename = match ? match[1] : defaultName;

    const blobUrl = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Free up the blob URL on the next tick.
    setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
  } catch (e) {
    toast.error(
      "Couldn't download CSV: " + (e?.response?.data?.detail || e?.message || "unknown error")
    );
  }
}
